interface Props {
  checked: boolean
  onChange: (v: boolean) => void
  disabled?: boolean
  label?: string
  className?: string
}

export function Checkbox({ checked, onChange, disabled, label, className = '' }: Props) {
  return (
    <label className={`inline-flex items-center gap-2.5 cursor-pointer select-none
      ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
      ${className}`}
    >
      <span
        role="checkbox"
        aria-checked={checked}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={(e) => { if (!disabled && (e.key === ' ' || e.key === 'Enter')) onChange(!checked) }}
        onClick={() => !disabled && onChange(!checked)}
        className={`w-5 h-5 rounded-md border-2 flex items-center justify-center shrink-0 transition-all
          ${checked
            ? 'bg-accent border-accent'
            : 'bg-transparent border-txt-meta/40 hover:border-accent/60'
          }`}
      >
        {checked && (
          <svg width="10" height="10" viewBox="0 0 12 12" fill="none" stroke="white" strokeWidth="2"
               strokeLinecap="round" strokeLinejoin="round">
            <polyline points="2 6 5 9 10 3"/>
          </svg>
        )}
      </span>
      {label && (
        <span className="text-txt-primary text-sm leading-tight">{label}</span>
      )}
    </label>
  )
}
